// Tour Types

export const TOUR_TYPE_IWC = 'iwc'
export const TOUR_TYPE_VIRTUAL_TOUR = 'virtual-tour'

export default {
    TOUR_TYPE_IWC,
    TOUR_TYPE_VIRTUAL_TOUR,
}
